import React, { PureComponent } from 'react';
import { GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class Importe extends PureComponent {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        this.props.changeImporte(event.target.value);
    }

    ValidateImporte(rule, value, callback) {
        if (value == undefined || value == "") {
            callback();
        }
        else {
            if (isNaN(value)){
                callback('Debe ingresar un valor numérico.');
            }
            else {
                if (value > 0) {
                    callback();
                }
                else {
                    callback('Debe ingresar un importe mayor a 0.');
                }
            }
        }
    }

    render() {
        const me = this;
        const { ingresoCobranza, form } = this.props;
        const { getFieldProps, getFieldError } = form;
        let errors;
        let errorContainer = <label className="error">
        {(errors = getFieldError('inputImporte')) ? errors.join(',') : null}</label>

        let error = ((getFieldError('inputImporte')) ? true : false);

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-5">
                    <label className="label-primary">Importe</label>
                    <GenericInputValidate
                        getFieldProps={getFieldProps('inputImporte', {
                            onChange(e) {
                                me.onChange(e);
                            },
                            rules: [{
                                required: true,
                                message: 'Ingrese importe.',
                            }, {
                                validator: this.ValidateImporte
                            }]
                        })}
                        id="inputImporte"
                        name="inputImporte"
                        value={ingresoCobranza.importe}
                        className="form-control default-input"
                        title="Ingrese Importe."
                    />
                    {error && errorContainer}
                </div>
            </div>
        );
    }
}

export default Importe;